"use client";
import React, { ReactNode, memo } from "react";
import { Box, InputLabelProps } from "@mui/material";
import {
  Control,
  Controller,
  ControllerProps,
  FieldPath,
  FieldValues,
  RegisterOptions,
} from "react-hook-form";
import { AppFromLabelField } from "@/common";

import AppCombobox, { AppComboboxProps } from "../AppCombobox";
import { AppOptionType } from "@/models";

const AppFormControlCombobox = <T extends FieldValues>({
  label,
  options,
  control,
  name,
  rules,
  isMultiple = false,
  controlProps,
  labelProps,
  actionsButton,
  autocompleteProps,
  onChangeValueForm,
  classNameContainer,
}: AppFormControlComboboxProps<T>) => {
  return (
    <AppFromLabelField
      label={label}
      labelProps={{
        ...labelProps,
      }}
      className={classNameContainer}
      required={labelProps?.required}
    >
      <Box className="flex items-center flex-row">
        <Controller
          control={control}
          name={name}
          rules={rules}
          render={({ field: { onChange, ...otherFieldProps } }) => {
            return (
              <AppCombobox
                {...otherFieldProps}
                disableCloseOnSelect={isMultiple}
                multiple={isMultiple}
                options={options}
                onChange={(_, data) => {
                  if (onChangeValueForm instanceof Function)
                    onChangeValueForm(data);

                  onChange(data);
                }}
                {...autocompleteProps}
                textFieldProps={{
                  ...autocompleteProps?.textFieldProps,
                }}
              />
            );
          }}
          {...controlProps}
        />
        {actionsButton}
      </Box>
    </AppFromLabelField>
  );
};

export type AppFormControlComboboxProps<T extends FieldValues> = {
  label?: string | ReactNode;
  options: Array<AppOptionType>;
  control: Control<any>;
  name: FieldPath<T>;
  isMultiple?: boolean;
  rules?: RegisterOptions;
  controlProps?: Omit<ControllerProps, "render" | "name" | "control">;
  actionsButton?: ReactNode;
  labelProps?: InputLabelProps;
  autocompleteProps?: Omit<AppComboboxProps, "options">;

  onChangeValueForm?: (data?: Array<AppOptionType>) => void;
  classNameContainer?: string;
};

export default memo(AppFormControlCombobox);
